/**
 * maps module entry (owner: maps-builder).
 *
 * Public surface (kept from the integrator stub): `MapRuntime`, `createMapRuntime`, `MAPS`, `getMap`.
 * Additions: collision grid + slide helper, rect queries, schema validator, tileset registry, dev
 * grey-box kit, map registration and the `maps` showcase.
 *
 * Node-safe imports for tests/tools: `@/maps/runtime`, `@/maps/collision`, `@/maps/queries`,
 * `@/maps/schema`, `@/maps/devmap`, `@/maps/devkit`, `@/maps/tilesets` (this index pulls in Phaser
 * through the showcase).
 */
export { createMapRuntime, resolveMapTileset, backgroundCoverage, MAPS, getMap, hasMap, registerMap, type MapRuntime, type MapRuntimeFull, type MapRuntimeOptions } from './runtime';
export { CollisionGrid, DEFAULT_BODY, slideMove, type BodySize, type SlideResult } from './collision';
export { rectContains, rectsIntersect, rectCenter, distSqToRectCenter, exitAt, interactionsAt, firstRectAt, rectsAt, tileRect, type Rect } from './queries';
export { validateMap, validateMapSet, assertValidMap, type MapValidation } from './schema';
export { registerTileset, getTileset, resolveTileset, listTilesets, clearTilesets, type TilesetDef } from './tilesets';
export {
  makeDevMap, DevTile, DEV_TILESET_ID, DEV_TILE_NAMES,
  ensureDevTileset, ensureDevMarker, ensureDevBackground, ensureDevProp, ensureDevGlow, ensureDevTextures,
  DEV_TILESET_TEXTURE, DEV_MARKER_TEXTURE, DEV_SKY_TEXTURE, DEV_PROP_TEXTURE, DEV_GLOW_TEXTURE,
} from './devkit';

import { SHOWCASES } from '@/content/ShowcaseScene';
import { mapsShowcase } from './showcase';

/** Registers `?showcase=maps` (called by the integrator from main.ts). */
export function registerShowcase(): void {
  SHOWCASES['maps'] = mapsShowcase;
}
